import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import './Add_User.css';
import Footer from './Footer.js';  // Import Footer component
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from "./Constants.js";

const Add_User = () => {
  const [newUser, setNewUser] = useState({
    USER_ID: '',
    USER_NAME: '',
  });
  const [formError, setFormError] = useState(null);
  const [user, setUser] = useState(null);  // To store the user data (isAdmin or similar)
  const [error, setError] = useState(null); // To store error message if any
  const [loading, setLoading] = useState(true); // To manage loading state
  const navigate = useNavigate(); // Use navigate hook

  // Fetch user profile when component mounts
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        setUser(data.profile.is_uniform_access_given); // Assuming the response contains the user profile info
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []); // Empty dependency array ensures this only runs once on component mount

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({
      ...newUser,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple form validation
    if (!newUser.USER_ID || !newUser.USER_NAME) {
      setFormError('Both fields are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('USER_ID', newUser.USER_ID);
      formData.append('USER_NAME', newUser.USER_NAME);

      const response = await fetch(`${BASE_URL}add_user`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to add user');
      }

      // Redirect to the Manage User page after successful submission
      navigate('/manage_users'); // You can modify this route if needed

    } catch (err) {
      setFormError(err.message);
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Optionally handle loading state
  }

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar />
      <div className="page-container">
        <Header />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  {/* Add User Card */}
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Add New User</h2>
                    </div>
                    <div className="card-body">
                      {/* Add User Form */}
                      <form onSubmit={handleSubmit}>
                        {formError && <div className="alert alert-danger">{formError}</div>}

                        <div className="form-group">
                          <label htmlFor="USER_ID">User ID</label>
                          <input
                            type="text"
                            id="USER_ID"
                            name="USER_ID"
                            className="form-control"
                            value={newUser.USER_ID}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="USER_NAME">User Name</label>
                          <input
                            type="text"
                            id="USER_NAME"
                            name="USER_NAME"
                            className="form-control"
                            value={newUser.USER_NAME}
                            onChange={handleInputChange}
                          />
                        </div>

                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer /> {/* Footer will stick to the bottom */}
      </div>
    </div>
  );
};

export default Add_User;
